module.exports = __webpack_public_path__ + "img/parco-auto-white.cd15c01f.svg";